import * as React from 'react'
import * as moment from 'moment'
import CloudinaryImage from 'web-makeup/dist/CloudinaryImage'
import { redirect } from 'web-ui/dist/helpers/redirect'

import { useMutation } from '@apollo/react-hooks'
import ReactTooltip from 'react-tooltip'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { ProjectLevelLabels } from '../../enums/brand-dashboard'
import EnvironmentContext from '../../../EnvironmentContext'

import { numberWithCommas } from '../../../../helpers/priceFormater'
import { DUPLICATE_PROJECT } from '../../../../mutations/DuplicateProject'
import { LOSE_PROJECT } from '../../../../mutations/LoseProject'
import { client as apolloClient } from '../../../ApolloProvider/ApolloProvider'
import { UserContext } from '../../../../components/UserProvider/UserProvider'
import { useProductize } from '../../../../hooks/useProductize'

import PopUp from '../PopUp/PopUp'
import BrandDashboardLoader from '../BrandDashbboardLoader/BrandDashbboardLoader'
import { ReactToolTipStyles } from '../BrandWalletCard/BrandWalletCard.style'

import {
  Container,
  Content,
  HiddenLabel,
  Thumbnail,
  Price,
  ProjectStats,
  Stat,
  ProjectTitle,
  DueDate,
  Tags,
  Tag,
  Dots,
  PopupMenu,
  Item,
  PopupWrapper,
  ProductTitle,
  ProductDescription,
  ProductInnerWrapper,
  FooterFlex,
  CardLink,
  Loading,
  OrderLink,
  BrandName,
  LocationTag,
  Separator,
  ProductLink,
} from './BrandOrderCard.style'

export interface BrandOrderCardProps {
  project?: any
  product?: boolean
  template?: boolean
  setActiveTabCallback?: (e: string) => void
  refetch?: () => void
  brandOrderUuid?: string
  productize?: boolean
  isSolution?: boolean
  build?: string
}

const BrandOrderCard: React.FC<BrandOrderCardProps> = ({
  project,
  product,
  setActiveTabCallback,
  refetch,
  template,
  brandOrderUuid,
  productize,
  isSolution,
  build,
}) => {
  const { BRAND_BASE_URL, GEN1_BASE_URL, ORDER_APP, ORDER_SUMMARY_URL } =
    React.useContext(EnvironmentContext) || ''
  const [isActive, setIsActive] = React.useState(false)
  const [isPopUpActive, setIsPopUpActive] = React.useState(false)
  const dataType = isSolution ? `solutions` : `services`

  const {
    description,
    dueDate,
    id,
    imageUrls,
    isFavorite,
    isHidden,
    jobs,
    link,
    location,
    name,
    price,
    projectLevel,
    shoots,
    slug,
    state,
    submitter,
    thumbnailUrl,
    uuid,
    videos,
    orderType,
    stateDetail,
  } = project || '{}'

  const flags = useFlags()
  const enablePreferences = flags['brand-dashboard-preferences']
  const enable2024NavigationBlack = flags['2024-navigation-black']

  const [hiding, setHiding] = React.useState(false)
  const [favoriting, setFavoriting] = React.useState(false)
  const { setFeatured, setUnfeatured, setHidden, setUnhidden } = useProductize(
    BRAND_BASE_URL,
    brandOrderUuid,
    refetch,
    dataType,
    id
  )

  const { amount, currency } = price || ''
  const { name: submitterName } = submitter || ''
  const [
    duplicateProject,
    { loading: duplicateProjectLoading, data: duplicatedProjectData },
  ] = useMutation(DUPLICATE_PROJECT, {
    client: apolloClient,
  })

  const projectLocation = () => {
    if (shoots && shoots.length === 1) {
      return shoots
    }
    if (shoots && shoots.length > 1) {
      const objectsJSON = shoots.map(obj => JSON.stringify(obj.location))
      const objectJSONSet = new Set(objectsJSON)
      const uniqueJSONArray = Array.from(objectJSONSet)
      const uniqueObjectsByContent = uniqueJSONArray.map((object: string) => JSON.parse(object))
      return uniqueObjectsByContent
    }
    return shoots
  }

  const [
    reOrderProject,
    { loading: reOrderProjectLoading, data: reOrderProjectData },
  ] = useMutation(DUPLICATE_PROJECT, {
    client: apolloClient,
  })

  const [loseProject, { data: deletePojectData, loading: deleteProjectLoading }] = useMutation(
    LOSE_PROJECT,
    {
      client: apolloClient,
    }
  )

  const outsideClick = ref => {
    React.useEffect(
      () => {
        const handleClickOutside = event => {
          if (
            ref.current &&
            !ref.current.contains(event.target) &&
            triggerRef.current &&
            !triggerRef.current.contains(event.target)
          ) {
            setIsActive(false)
          }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
          document.removeEventListener('mousedown', handleClickOutside)
        }
      },
      [ref]
    )
  }

  React.useEffect(
    () => {
      if (
        deletePojectData &&
        deletePojectData.deleteProject &&
        deletePojectData.deleteProject.success
      ) {
        if (refetch) {
          refetch()
        }
      }
    },
    [deletePojectData]
  )
  React.useEffect(
    () => {
      if (duplicatedProjectData && duplicatedProjectData.duplicateProject) {
        if (duplicatedProjectData.duplicateProject.projectLevel === 'TEMPLATES') {
          const duplicateProject1 = async () => {
            if (setActiveTabCallback) {
              await setActiveTabCallback('products')
            }

            redirect(`/brand-dashboard/orders/${brandOrderUuid}`)

            if (refetch) {
              refetch()
            }
          }
          duplicateProject1()
        }
        if (duplicatedProjectData.duplicateProject.projectLevel === 'LEVEL2') {
          window.location.href = `${GEN1_BASE_URL}/video_projects/${
            duplicatedProjectData.duplicateProject.uuid
          }`
        }
        if (
          duplicatedProjectData.duplicateProject.projectLevel !== 'LEVEL2' &&
          duplicatedProjectData.duplicateProject.projectLevel !== 'TEMPLATES'
        ) {
          window.location.href = `${GEN1_BASE_URL}/video_projects/${
            duplicatedProjectData.duplicateProject.uuid
          }`
        }
      }
    },
    [duplicatedProjectData]
  )
  React.useEffect(
    () => {
      if (reOrderProjectData && reOrderProjectData.duplicateProject) {
        window.location.href = `${GEN1_BASE_URL}/video_projects/${
          reOrderProjectData.duplicateProject.uuid
        }`
      }
    },
    [reOrderProjectData]
  )

  const wrapperRef = React.useRef(null)
  const triggerRef = React.useRef<HTMLDivElement>(null)

  const getPreferenceIcon = React.useCallback((condition, trueIcon, falseIcon, loading) => {
    const icon = loading ? 'dots-loader-white-v2' : condition ? trueIcon : falseIcon
    return `https://res.cloudinary.com/ninety-seconds/image/upload/v1707190545/-design-system/${icon}.svg`
  }, [])

  outsideClick(wrapperRef)

  const ConditionalWrapper = ({ condition, wrapper1, wrapper2, children }) =>
    condition ? wrapper1(children) : wrapper2(children)

  const projectNameShort =
    name && name.endsWith('Template')
      ? name
          .split(' ')
          .slice(0, -1)
          .join(' ')
      : name

  const { brandUuid } = React.useContext(UserContext)

  const locationToolTip =
    projectLocation() &&
    projectLocation().map((item, index) => (
      <span key={index}>
        {item.country},{` `}
        {item.city}
        <br />
      </span>
    ))

  const jobsDatesArray =
    jobs &&
    jobs.map(job => {
      return job.dueDate
    })
  const completedOn =
    jobsDatesArray && jobsDatesArray.length > 0 && jobsDatesArray.reduce((a, b) => (a > b ? a : b))
  const projectDate = moment(new Date(state === 'COMPLETED' ? completedOn : dueDate)).format(
    'DD MMM, YYYY'
  )

  const urlBuild = () => {
    if (build !== undefined) {
      return build
    }
    return ''
  }

  const orderParams = enable2024NavigationBlack
    ? `?selectedBrandUuid=${brandOrderUuid}&brandId=${brandOrderUuid}${urlBuild()}`
    : `?selectedBrandUuid=${brandUuid}&brandId=${brandOrderUuid}${urlBuild()}`

  const projectLink = productize
    ? ORDER_APP && `${ORDER_APP}/${isSolution ? `solutions` : `services`}/${slug}${orderParams}`
    : product && link
      ? `${link}${orderParams}`
      : orderType === 'order'
        ? ORDER_SUMMARY_URL && `${ORDER_SUMMARY_URL}/orders/${uuid}`
        : GEN1_BASE_URL && `${GEN1_BASE_URL}/video_projects/${uuid}`

  return (
    <Container data-testid="container">
      <ReactToolTipStyles />
      {(duplicateProjectLoading || deleteProjectLoading || reOrderProjectLoading) && (
        <Loading>
          <BrandDashboardLoader />
        </Loading>
      )}
      {template &&
        isPopUpActive && (
          <PopUp
            onNo={() => setIsPopUpActive(false)}
            onYes={async () => {
              await loseProject({
                variables: {
                  projectUuid: uuid,
                },
              })
              setIsPopUpActive(false)
              if (refetch) {
                refetch()
              }
            }}
          />
        )}

      {isActive && productize && enablePreferences ? (
        <PopupMenu ref={wrapperRef}>
          <Item
            icon={getPreferenceIcon(
              isFavorite,
              'icon-remove-featured',
              'icon-add-featured',
              favoriting
            )}
            onClick={() => {
              setFavoriting(true)
              const operation = isFavorite ? setUnfeatured : setFeatured
              operation(() => setFavoriting(false))
            }}
          >
            {isFavorite ? 'Remove from featured' : 'Feature this product'}
          </Item>
          <Item
            data-testid="remove-template"
            icon={getPreferenceIcon(isHidden, 'icon-show-product', 'icon-hide-product', hiding)}
            onClick={() => {
              setHiding(true)
              const operation = isHidden ? setUnhidden : setHidden
              operation(() => setHiding(false))
            }}
          >
            {isHidden ? 'Show this product' : 'Hide this product'}
          </Item>
        </PopupMenu>
      ) : null}

      {isActive &&
        !productize && (
          <PopupMenu ref={wrapperRef}>
            {template ? (
              <>
                <Item
                  onClick={() => {
                    GEN1_BASE_URL &&
                      window.open(`${GEN1_BASE_URL}/video_projects/${uuid}`, '_blank')
                    setIsActive(false)
                  }}
                  icon="https://res.cloudinary.com/ninety-seconds/image/upload/v1581041663/-icons-browse-order-deliver/-order/-configure/icon-edit-white.svg"
                >
                  Edit
                </Item>
                <Item
                  data-testid="remove-template"
                  onClick={() => {
                    setIsPopUpActive(true)
                    setIsActive(false)
                  }}
                  icon="https://res.cloudinary.com/ninety-seconds/image/upload/v1666261764/-design-system/remove-icon-white.svg"
                >
                  Remove from templates
                </Item>
              </>
            ) : (
              <>
                <Item
                  data-testid="reorder"
                  onClick={async () => {
                    await reOrderProject({
                      variables: {
                        projectUuid: uuid,
                        projectLevel,
                      },
                    })
                    await setIsActive(false)
                    if (refetch) {
                      refetch()
                    }
                  }}
                  icon="https://res.cloudinary.com/ninety-seconds/image/upload/v1661170997/icon-refresh.svg"
                >
                  Re-order
                </Item>
                <Item
                  data-testid="save-as-template"
                  onClick={async () => {
                    await duplicateProject({
                      variables: {
                        projectUuid: uuid,
                        projectLevel: 'TEMPLATES',
                      },
                    })
                    await setIsActive(false)
                    if (refetch) {
                      refetch()
                    }
                  }}
                  icon="https://res.cloudinary.com/ninety-seconds/image/upload/v1661170997/icon-publish.svg"
                >
                  Save to my templates
                </Item>
              </>
            )}
          </PopupMenu>
        )}
      <Content product={product} data-testid="order-card">
        {(!product || (productize && enablePreferences)) && (
          <PopupWrapper
            data-testid="more-options"
            ref={triggerRef}
            onClick={e => {
              e.stopPropagation()
              setIsActive(!isActive)
            }}
          >
            <Dots />
          </PopupWrapper>
        )}
        <ConditionalWrapper
          condition={!template}
          wrapper1={children => (
            <CardLink href={projectLink} target="_blank">
              {children}
            </CardLink>
          )}
          wrapper2={children => <div>{children}</div>}
        >
          <Thumbnail
            background={
              productize
                ? imageUrls && (imageUrls.productizeLg || imageUrls.productizeMd)
                : thumbnailUrl
            }
            product={product}
            template={template}
          >
            {!product && (
              <Price>
                <div>
                  <span>{currency && currency.code}</span> {currency && currency.symbol}
                  {numberWithCommas(amount) || 0}
                </div>
              </Price>
            )}
            {enablePreferences && isHidden ? (
              <HiddenLabel>
                <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1707190545/-design-system/icon-hide-product.svg" />
                <span>This product is hidden</span>
              </HiddenLabel>
            ) : null}
          </Thumbnail>
          {product && (
            <>
              <ProductInnerWrapper>
                <ProductTitle data-testid="product-title">{name}</ProductTitle>
                <ProductDescription data-testid="product-description">
                  {description}
                </ProductDescription>
              </ProductInnerWrapper>
              <FooterFlex>
                <div>
                  Starts from{' '}
                  <strong>
                    <span>{currency && currency.code}</span> {currency && currency.symbol}
                    {numberWithCommas(amount) || 0}
                  </strong>
                </div>

                {product ? (
                  <ProductLink>
                    Order now
                    <img
                      src="https://res.cloudinary.com/ninety-seconds/image/upload/v1691152853/righ-arrow-new.svg"
                      alt="arrow-icon"
                    />
                  </ProductLink>
                ) : (
                  <OrderLink
                    data-testid="order-product"
                    href={
                      product && link
                        ? `${link}${orderParams}`
                        : GEN1_BASE_URL && `${GEN1_BASE_URL}/video_projects/${uuid}`
                    }
                    target="_blank"
                  >
                    Order now
                    <img
                      src="https://res.cloudinary.com/ninety-seconds/image/upload/v1691152853/righ-arrow-new.svg"
                      alt="arrow-icon"
                    />
                  </OrderLink>
                )}
              </FooterFlex>
            </>
          )}
          {!product && (
            <>
              {submitterName && (
                <BrandName data-testid="card-brand-name">
                  CREATED BY:
                  {`  `}
                  <strong>{submitterName}</strong>
                </BrandName>
              )}
              <ProjectTitle data-testid="project-title">{name}</ProjectTitle>

              <ReactTooltip
                id={`registerTip-${uuid}`}
                place="bottom"
                type="dark"
                effect="solid"
                offset={{ right: 100, top: 15 }}
              >
                {locationToolTip}
              </ReactTooltip>

              {projectLocation() && projectLocation().length > 1 ? (
                <>
                  <LocationTag data-tip data-for={`registerTip-${uuid}`}>{`${
                    projectLocation().length
                  } LOCATIONS`}</LocationTag>
                </>
              ) : location && location.country && location.city ? (
                <>
                  <LocationTag data-testid="location">
                    {location && location.country},{` `}
                    {location && location.city}
                  </LocationTag>
                </>
              ) : (
                <div style={{ height: '2.25rem' }} />
              )}
              {!dueDate && <div style={{ height: '3.125rem' }} />}
              {dueDate &&
                !template && (
                  <>
                    <Separator />
                    <DueDate data-testid="due-date">
                      {state === 'COMPLETED' ? 'Completed' : 'Due'}:{` `}
                      <strong>{projectDate}</strong>
                    </DueDate>
                  </>
                )}
              <Separator />
              <Tags className={template ? 'template' : ''}>
                {!template && (
                  <>
                    {state === 'COMPLETED' && <Tag className="completed">COMPLETED</Tag>}
                    {state === 'ACTIVE' && (
                      <Tag className="active">
                        {' '}
                        <CloudinaryImage
                          useSourceFormat
                          source={{
                            id: 'v1603119758/-design-system/icon-live.svg',
                            type: 'upload',
                          }}
                        />
                        LIVE
                      </Tag>
                    )}
                  </>
                )}
                {stateDetail && <Tag>{stateDetail}</Tag>}
                <Tag>{projectLevel ? ProjectLevelLabels[projectLevel] : 'PAY AS YOU GO'}</Tag>
                {template && (
                  <OrderLink
                    data-testid="order-project"
                    onClick={e => {
                      e.stopPropagation()
                      duplicateProject({
                        variables: {
                          projectUuid: uuid,
                          projectLevel: 'LEVEL2',
                          projectName: projectNameShort,
                        },
                      })
                    }}
                  >
                    Order
                    <img
                      src="https://res.cloudinary.com/ninety-seconds/image/upload/v1691152853/righ-arrow-new.svg"
                      alt="arrow-icon"
                    />
                  </OrderLink>
                )}
              </Tags>
              <ProjectStats>
                <Stat data-testid="stat-shoots">
                  <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1664329108/-design-system/icon-type-solution.svg" />
                  {shoots && shoots.length} X SHOOTS
                </Stat>
                <Stat data-testid="stat-videos">
                  <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1664329109/-design-system/icon-type-edit.svg" />
                  {videos && videos.length} X VIDEOS
                </Stat>
              </ProjectStats>
            </>
          )}
        </ConditionalWrapper>
      </Content>
    </Container>
  )
}

export default React.memo(BrandOrderCard)



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/BrandOrderCard/BrandOrderCard.tsx